/** Logo.tsx — CME Studio brand mark. Ported from prototype shell.jsx. */

export function Logo({ size = 22 }: { size?: number }): JSX.Element {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ display: "block" }}>
        <rect x="2" y="2" width="20" height="20" rx="4" fill="#1E3A5F" />
        <path d="M6 12h4M6 8h4M6 16h4" stroke="#FAFAF8" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M14 6l4 6-4 6"
          stroke="#B8623E"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span
          style={{ fontWeight: 700, fontSize: 14, letterSpacing: "-0.01em", color: "var(--c-ink)" }}
        >
          cme
        </span>
        <span
          style={{
            fontSize: 9.5,
            color: "var(--c-ink-3)",
            fontWeight: 500,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            marginTop: 2,
          }}
        >
          studio
        </span>
      </div>
    </div>
  );
}
